webpackJsonp([261756379115546],{

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.1ca30819.png";

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.3bb498ff.png";

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.21a5925d.png";

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.b9ec253a.png";

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5.554a50fb.png";

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypist = __webpack_require__(28);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	__webpack_require__(27);
	
	var _messages = __webpack_require__(34);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _HeadlineWithFocus = __webpack_require__(6);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _ = __webpack_require__(868);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(869);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(870);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(871);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(872);
	
	var _10 = _interopRequireDefault(_9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-content-box' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Seismic Assessment'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement('img', { src: _2.default, style: { width: '100%', height: '100%' } }),
	      'In the last years, my work has been related to seismic vulnerability assessment. This is often related to existing structures which typically are not designed to resist earthquakes. It is commonly accepted that seismic assessment is not a prediction of the actual performance of a structure under a particular seismic attack but instead is the general understanding of the likely behaviour of the structure under a certain level of the seismic demand. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'In a few words...'
	      ),
	      'In simple terms, for a given the intensity of the earthquake demand, the purpose of seismic assessment is to assign a \u201Cscore\u201D to the examined structure in relation, but not limited, to its ability to preserve human life (called life safety performance objective). This is usually carried out according to a national or internationa standard. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement('img', { src: _6.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement('img', { src: _8.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Analysis techniques'
	      ),
	      'This can be done with different analysis techniques with different levels of refinement. The Linear Static and Linear Dynamic analyses are particularly simple and fast to perform but are limited to the elastic range (i.e. they cannot explicitly predict damage). On the other hand, Non-Linear analyses (static or dynamic) are more accurate and more onerous. The most advanced one is the Non-Linear Dynamic analysis (also called time history), which allows to predict the behaviour of the structure under a recorded or simulated ground motion. However, due to the main difficulties related to the time history, the mostly-adopted analysis technique is the Non-Linear Static (or pushover). In this case, the structure is pushed with forces to calculate its maximum capacity in terms of forces and, more importantly, in terms of displacements. See the section about ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'http://robswebdemo.hopto.org:8000/modeling' },
	        'numerical modeling'
	      ),
	      ' to see some foto/video example of analysis. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _10.default, style: { width: '100%', height: '100%' } })
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-assessment-en-jsx-a45b3de05eacf5ca3d12.js